import React from "react";
// nodejs library to set properties for components

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import { GridProps } from "@material-ui/core";

const styles = {
  grid: {
    padding: "5px 15px !important"
  }
};

export interface GridItemProps extends GridProps {

}

const useStyles = makeStyles(styles);

export default function GridItem(props: GridItemProps) {

  const classes = useStyles()
  return (
    <Grid item {...props} className={classes.grid} >

    </Grid>
  );
}
